var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCircleTransparent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M16.0003 29.3468C23.3641 29.3468 29.3337 23.3773 29.3337 16.0135C29.3337 8.64971 23.3641 2.68018 16.0003 2.68018C8.63653 2.68018 2.66699 8.64971 2.66699 16.0135C2.66699 23.3773 8.63653 29.3468 16.0003 29.3468Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.25342C13.24 9.25342 11 11.4934 11 14.2534C11 16.9601 13.12 19.1601 15.9333 19.2401C15.9733 19.2401 16.0267 19.2401 16.0533 19.2401C16.08 19.2401 16.12 19.2401 16.1467 19.2401C16.16 19.2401 16.1733 19.2401 16.1733 19.2401C18.8667 19.1468 20.9867 16.9601 21 14.2534C21 11.4934 18.76 9.25342 16 9.25342Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 25.8132C22.6666 27.9998 19.4933 29.3465 16 29.3465C12.5066 29.3465 9.33329 27.9998 6.95996 25.8132C7.27996 24.5998 8.14663 23.4932 9.41329 22.6398C13.0533 20.2132 18.9733 20.2132 22.5866 22.6398C23.8666 23.4932 24.72 24.5998 25.04 25.8132Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCircleTransparent);
export default __webpack_public_path__ + "static/media/profile-circle-transparent.f4f915fc3f6c92bcb40f501262d6c577.svg";
export { ForwardRef as ReactComponent };